<script setup lang="ts">
import { useSnackbarStore } from '~/store/snackbar';
const snackbarStore = useSnackbarStore();
</script>

<template>
  <div>
    <VApp theme="light">
      <VMain class="admin-layout">
        <v-snackbar
          v-model="snackbarStore.active"
          :color="snackbarStore.color"
          location="top center"
          @on-vnode-unmounted="snackbarStore.active = false"
        >
          {{ snackbarStore.content }}
        </v-snackbar>

        <div class="h-100">
          <slot />
        </div>
      </VMain>

      <v-footer
        app
        class="admin-footer"
      >
        <span>&copy; {{ new Date().getFullYear() }}</span>
        <v-spacer />
      </v-footer>
    </VApp>
  </div>
</template>
